import translateFieldsHelper from '../helpers/translateFieldsHelper';
import removeExtraSubFieldsHelper from '../helpers/removeExtraSubFieldsHelper';

const transform = referee => ({ ...translateFieldsHelper(referee, ['nationalities']) });

const reverseTransform = referee => ({ ...removeExtraSubFieldsHelper(referee, ['nationalities']) });

export { transform, reverseTransform };
